
import {
    GET_SINGLE_MEDIA_DATA,
    GET_SINGLE_MEDIA_DATA_SUCCESS,
    SEND_MEDIA_LIKE_FEEDBACK_SUCCESS,
    GIVE_VOTE_SUCCESS_SINGLE_MEDIA,
    UPDATE_SINGLE_MEDIA_VIEW_COUNT_SUCCESS
} from '../constants/actionTypes';



export const getSingleMediaData = (payload) => ({
    type: GET_SINGLE_MEDIA_DATA,
    payload
});

export const getSingleMediaDataSuccess = payload => ({
    type: GET_SINGLE_MEDIA_DATA_SUCCESS,
    payload
});

export const sendMediaLikeFeedBackSuccess = (payload) => ({
    type: SEND_MEDIA_LIKE_FEEDBACK_SUCCESS,
    payload
});

export const giveVoteSuccessSingleMedia = (payload) => ({
    type: GIVE_VOTE_SUCCESS_SINGLE_MEDIA,
    payload
});

export const updateSingleMediaCountSuccess = payload => ({
    type: UPDATE_SINGLE_MEDIA_VIEW_COUNT_SUCCESS,
    payload
})